var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"crm-box salesforce",attrs:{"title":"Salesforce"},on:{"click":_vm.addToSalesForce,"mouseover":function($event){_vm.salesforceTooltip = true},"mouseleave":function($event){_vm.salesforceTooltip = false}}},[_c('img',{attrs:{"src":require("@/assets/icons/png/crm/Salesforce.png")}})]):_c('spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }